<div class="high-risk-sampling">
  <h3 class="section-heading">High Risk Sampling</h3>
<p class="section-description">
  Ensure all high-risk Diagnosis Codes and HCCs (per 
  <a [href]="oigGuidanceUrl"
     target="_blank" 
     rel="noopener noreferrer"
     class="external-link">
    OIG guidance
  </a>) are automatically sent for review (“Overread”).
  When enabled, this setting guarantees all critical items will be reviewed, 
  regardless of Project or User Sampling settings.
</p>
</div>


<div class="checkbox-group__halves">
  <form-factory [formGroup]="riskFormGroup" [model]="highRiskCategoryEnabled"></form-factory>
</div>

<div class="attribute-container"  *ngIf="riskFormGroup.get('highRiskCategoryInput') && highRiskCategoryInput.items?.length">
  <form-factory [formGroup]="riskFormGroup" [model]="highRiskCategoryInput"></form-factory>
</div>

